import { useState } from "react";
import { Search, Copy, Send, X } from "lucide-react";

const STEPS = [
  { icon: Search, title: "1. Search what you need", text: "Type an everyday phrase like \"write an email\" or \"get more customers\" — no technical words needed." },
  { icon: Copy, title: "2. Copy the command", text: "Tap COPY COMMAND (or + EXAMPLE). Add a few of your own details after it." },
  { icon: Send, title: "3. Paste into your AI", text: "Paste it into ChatGPT, Claude or Gemini. Done — that's the whole trick." },
];

export const WelcomeTour = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  const Icon = s.icon;
  const finish = () => { localStorage.setItem("aish_tour_done", "1"); onDone(); };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="welcome-tour">
      <div className="bg-white rounded-3xl w-full max-w-sm p-8 text-center relative rise">
        <button data-testid="tour-skip-btn" onClick={finish} className="absolute top-4 right-4 text-slate-300 hover:text-slate-500 p-1"><X size={18} /></button>
        <p className="text-[10px] font-bold tracking-[0.18em] text-[#B8962E] uppercase">Universal Short-Command Prompt Dictionary™</p>
        <div className="w-16 h-16 rounded-2xl bg-emerald-50 text-emerald-700 flex items-center justify-center mx-auto mt-5">
          <Icon size={28} />
        </div>
        <h2 className="font-display text-xl font-bold mt-5">{s.title}</h2>
        <p className="text-sm text-slate-500 mt-2.5 leading-relaxed">{s.text}</p>
        <div className="flex justify-center gap-1.5 mt-6">
          {STEPS.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 bg-emerald-600" : "w-1.5 bg-slate-200"}`} />
          ))}
        </div>
        <button data-testid="tour-next-btn"
          onClick={() => (step < STEPS.length - 1 ? setStep(step + 1) : finish())}
          className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3.5 rounded-xl active:scale-[0.98] transition-all">
          {step < STEPS.length - 1 ? "Next" : "Start searching"}
        </button>
      </div>
    </div>
  );
};
